import React from "react";
import Custombutton from "../../utils/Custombutton";
import { Link } from "react-router-dom";

const ConfirmDetaiils = () => {
  return (
    <>
      <div
        className="order_details"
        style={{ borderRadius: "44px 44px 0px 0px" }}
      >
        <h1 className="mb-5">
          Confirm Your <br /> order details
        </h1>
        <h5 className="mb-4">Shipment Information</h5>
        <div className="row">
          <div className="col-6 mb-4">
            <label htmlFor="" className="mb-3">
              {" "}
              Name
            </label>
            <h6>Jacky</h6>
          </div>
          <div className="col-6 mb-4">
            <label htmlFor="" className="mb-3">
              {" "}
              Country
            </label>
            <h6>United States</h6>
          </div>
          <div className="col-6 mb-4">
            <label htmlFor="" className="mb-3">
              {" "}
              Email ID
            </label>
            <h6>Jak@gmail.com</h6>
          </div>{" "}
          <div className="col-6 mb-4">
            <label htmlFor="" className="mb-3">
              {" "}
              Town
            </label>
            <h6>Capo</h6>
          </div>{" "}
          <div className="col-6 mb-4">
            <label htmlFor="" className="mb-3">
              {" "}
              Estate
            </label>
            <h6>USA</h6>
          </div>
          <div className="col-6 mb-4">
            <label htmlFor="" className="mb-3">
              {" "}
              Postal Code
            </label>
            <h6>54000</h6>
          </div>
          <hr />
          <div className="col-6 mb-4">
            <h6>Shipping method</h6>
          </div>{" "}
          <div className="col-6 mb-4">
            <img src="/assets/images/dhl.png" alt="dhl" />
          </div>
        </div>
      </div>
      <div
        className="order_details mt-2"
        style={{ borderRadius: " 0px 0px 44px 44px" }}
      >
        <div className="row">
          <div className="col-6">
            <h4>Total</h4>
          </div>

          <div className="col-6">
            <h4>$150</h4>
          </div>
        </div>
      </div>
      <div className="d-flex align-items-center justify-content-between mt-4">
        <h6 className="ms-5">Edit</h6>
        <Link to='/payment'>
        <Custombutton
          className={"btn-outline gradient-outline gradient-text mt-5 mt-md-0 "}
          label={"Confirm & pay"}
          />
          </Link>
      </div>
    </>
  );
};

export default ConfirmDetaiils;
